import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { PlanificacionAyudantia } from "../../interfaces/AYUDANTIAS/Ayudantia"
import { PantallaCargaPage } from "../../pages/Modulos/PantallaCargaPage"


interface Props{
    ready: boolean,
    planificacion: PlanificacionAyudantia

}

export const PlanificacionAyudantias: React.FC<Props> = ({ready, planificacion}) =>{
    return(
        <Paper elevation={3} sx={{ width: '50%', padding: 2, marginBottom: 3 }}>
            {
            ready ?
            // <TableContainer>
            //     <Table>
            //         <TableHead>
            //             <TableRow>
            //                 <TableCell colSpan={4} sx={{ fontWeight: 'bold', fontSize: '1.1rem', textAlign: 'center' }}>
            //                     Planificación de horas de ayudantías
            //                 </TableCell>
            //             </TableRow>
            //             <TableRow>
            //                 <TableCell sx={{fontWeight:'bold'}}>Horas planificadas totales</TableCell>
            //                 <TableCell sx={{ textAlign: 'center'}}>{planificacion.horasPlanificadasTotales.toString()}</TableCell>
            //             </TableRow>
            //             <TableRow>
            //                 <TableCell sx={{fontWeight:'bold'}}>Horas otorgadas espol</TableCell>
            //                 <TableCell sx={{ textAlign: 'center'}}>{planificacion.horasOtorgadasEspol.toString()}</TableCell>
            //             </TableRow>
            //             <TableRow>
            //                 <TableCell sx={{fontWeight:'bold'}}>Horas otorgadas proyectos</TableCell>
            //                 <TableCell sx={{ textAlign: 'center'}}>{planificacion.horasOtorgadasProyecto.toString()}</TableCell>
            //             </TableRow>
            //             <TableRow>
            //                 <TableCell sx={{fontWeight:'bold'}}>Horas otorgadas Ad honorem</TableCell>
            //                 <TableCell sx={{ textAlign: 'center'}}>{planificacion.horasOtorgadasAdHonorem.toString()}</TableCell>
            //             </TableRow>
            //             <TableRow>
            //                 <TableCell sx={{fontWeight:'bold'}}>Horas restantes</TableCell>
            //                 <TableCell sx={{ textAlign: 'center'}}>{planificacion.horasRestantes.toString()}</TableCell>
            //             </TableRow>
            //         </TableHead>
            //     </Table>
            // </TableContainer>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={4} sx={{ fontWeight: 'bold', fontSize: '1.1rem', textAlign: 'center' }}>
                            Planificación de horas de ayudantías
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell sx={{fontWeight:'bold', textAlign: 'center'}}>Tipo de Ayudantía</TableCell>
                            <TableCell sx={{fontWeight:'bold', textAlign: 'center'}}>Horas planificadas</TableCell>
                            <TableCell sx={{fontWeight:'bold', textAlign: 'center'}}>Horas aprobadas</TableCell>
                            <TableCell sx={{fontWeight:'bold', textAlign: 'center'}}>Horas restantes</TableCell>
                        </TableRow>

                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={{textAlign: 'center'}}>ESPOL</TableCell>
                            <TableCell sx={{textAlign: 'center'}}>{planificacion.horasPlanificadasTotales.toString()}</TableCell>
                            <TableCell sx={{textAlign: 'center'}}>{planificacion.horasOtorgadasEspol.toString()}</TableCell>
                            <TableCell sx={{textAlign: 'center'}}>{planificacion.horasRestantes.toString()}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{textAlign: 'center'}}>Proyectos</TableCell>
                            <TableCell sx={{textAlign: 'center'}}>-</TableCell>
                            <TableCell sx={{textAlign: 'center'}}>{planificacion.horasOtorgadasProyecto.toString()}</TableCell>
                            <TableCell sx={{textAlign: 'center'}}>-</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{textAlign: 'center'}}>Ad honorem</TableCell>
                            <TableCell sx={{textAlign: 'center'}}>-</TableCell>
                            <TableCell sx={{textAlign: 'center'}}>{planificacion.horasOtorgadasAdHonorem.toString()}</TableCell>
                            <TableCell sx={{textAlign: 'center'}}>-</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            :
            <PantallaCargaPage />
            }

        </Paper>
    )
}